export const API_HOST = 'https://staging.api.glance.inmobi.com';
export const API_KEY = 'X-Api-Key';
export const API_KEY_VALUE = 'ec65d4939b9e6836701f785a407ffd20';
//# sourceMappingURL=development.js.map